<template>
  <div class="container">
    <div class="top_card flex">
      <div class="org_name">
        <el-input
          size="small"
          placeholder="机构名称"
          prefix-icon="el-icon-search"
          v-model="org_name"
        ></el-input>
      </div>
      <el-button type="primary" size="small" @click="setOrgEdit(1)">
        {{ $t("label.open.create_org") }}
        <i class="el-icon-circle-plus-outline"></i>
      </el-button>
    </div>
    <div class="bottom_card">
      <el-col :span="8">
        <org-tree ref="tree" :keyword="org_name" :orgdata="orgdata" @setOrg="setOrg" />
      </el-col>
      <el-col :span="16">
        <org-detail
          :orgInfo="orgInfo"
          @editOrg="setOrgEdit"
          @deleteOrg="delete_org"
        />
      </el-col>
    </div>
    <org-edit
      :show="showEditOrg"
      :orgdata="orgdata"
      :rowInfo="orgInfo"
      :editOrgState="editOrgState"
      @toggleShow="toggleShowEditOrg"
      @refush="getOrgList"
    />
      <!-- <i
        class="iconfont icon-yonghuguanli"
      ></i> -->
  </div>
</template>

<script>
import OrgTree from "./components/orgTree.vue";
import OrgDetail from "./components/orgDetail.vue";
import OrgEdit from "./components/orgEdit.vue";
import {
  queryOrgInfo,
  orgIsExist,
  addOrg,
  editOrg,
  removeOrg,
} from "@/api/index.js";
export default {
  name: "orgManage",
  data() {
    return {
      orgExist: -1,
      showEditOrg: false,
      editOrgState: 1, // 当前操作机构状态  1 新增 2 编辑
      org_name: "",
      currentOrg: "", // 当前机构id
      orgList: [],
      orgInfo: {
        id: "",
        label: "", // 机构名称
        pname: "", // 上级机构名称
        created_at: "", // 创建时间
        describe: "", // 机构描述
      },
      orgdata: [
        {
          id: 1,
          label: "",
          des: "",
          children: []
        }
      ],
    };
  },
  components: {
    OrgTree,
    OrgDetail,
    OrgEdit,
  },
  methods: {
    // 删除机构
    delete_org() {
      this.$confirm("此操作将永久删除该机构, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // removeOrg({ id: this.orgInfo.id }).then((res) => {
          removeOrg({ org_id: this.currentOrg }).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getOrgList()
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
          return
        });
    },
    // 新增机构
    add_org(params) {
      addOrg(params)
        .then((res) => {
          if (res.data.code) {
            this.$messagee({
              type: "success",
              message: res.data.msg,
            });
            this.getOrgList();
          } else {
            this.$messagee({
              type: "error",
              message: res.data.msg,
            });
          }
        })
        .catch((error) => {
          // this.$messagee({
          //   type: "error",
          //   message: error,
          // });
          return
        });
    },
    update_org(params) {
      editOrg(params)
        .then((res) => {
          if (res.data.code) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getOrgList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    // 编辑机构
    getOrgList() {
      // 获取当前所有机构列表
      queryOrgInfo().then((res) => {
        // this.orgdata = res.data.data;
        this.orgdata = this.generateOptions(res.data)
      this.currentOrg = this.orgdata[0].id
      // console.log(this.currentOrg, "dataaaaaa")

      this.$refs.tree.handleCheckChange(this.orgdata[0])
      });
      // this.orgdata = this.generateOptions(temp)
      // this.currentOrg = this.orgdata[0].id
      // // console.log(this.currentOrg, "dataaaaaa")

      // this.$refs.tree.handleCheckChange(this.orgdata[0])
      // console.log(t, "ttttt")
    },
    // 递归处理接口数据
    generateOptions(params) {
      let result = [];
      for (const param of params) {
        if (param.pid == 0) {
          // 判断是否为顶层节点
          let parent = {
            id: param.org_id,
            label: param.name,
            pname: param.pname,
            describe: param.describe,
            created_at: param.created_at
          };
          parent.children = this.getchilds(param.org_id, params); // 获取子节点
          result.push(parent);
        }
      }
      return result;
    },
    getchilds(value, array) {
      const childs = [];
      for (const arr of array) {
        // 循环获取子节点
        if (arr.pid === value) {
          childs.push({
            id: arr.org_id,
            label: arr.name,
            pname: arr.pname,
            describe: arr.describe,
            created_at: arr.created_at
          });
        }
      }
      for (const child of childs) {
        // console.log(childs, "sssss")
        // 获取子节点的子节点
        const childscopy = this.getchilds(child.id, array); // 递归获取子节点
        if (childscopy.length > 0) {
          child.children = childscopy;
        }
      }
      return childs;
    },
    // orgIsExist(name) {
    //   // 判断当前机构名称是否重复
    //   orgIsExist({ name }).then((res) => {
    //     console.log(res, "---+++");
    //     if (res.data.data == 1) {
    //       // 机构存在
    //       this.$message({
    //         type: "error",
    //         message: res.data.msg,
    //       });
    //     } else {
    //       // 机构不存在
    //     }
    //   });
    // },
    toggleShowEditOrg() {
      this.showEditOrg = !this.showEditOrg;
    },
    setOrgEdit(state) {
      this.editOrgState = state;
      this.toggleShowEditOrg();
    },
    setOrg(id, info) {
      // console.log(id, info, "iddddd");
      // 当前机构id
      this.orgInfo = info
      this.currentOrg = id;
    },
  },
  mounted() {
    this.getOrgList()
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.top_card {
  padding:4px 0;
  width: 100%;
  justify-content: space-between;
}
.bottom_card {
  display: flex;
  flex: 1;
}
.org_name {
  font-weight: bold;
}
</style>
